import Swiper from 'swiper';
import $ from 'jquery';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/contact-block.css';

import '../css/nest-menu.css';
import '../css/section-half.css';

import '../css/card-block.css';
import '../css/promotion/book-button.css';
import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';
import '../css/index/slide-info.css';
import '../css/room/room-information.css';
import '../css/room/note-block.css';
import '../css/room/room-wrapper.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import getRoomDetail from './request/roomDetail';
import getPromotionList from './request/promotionList';
import generateLinkCard from './promotion/generateLinkCard';
import wrapSwiperSlide from './about/wrapSwiperSlide';
import { uploadUri } from './appConfig';
import languageBasedTag from './languageBasedTag';
import generateRoomWrapper from './room/generateRoomWrapper';
import setBookingLink from './setBookingLink';
import wordingSetter from './wordingSetter';
import getWordingJson from './request/wordingJson';
import urlParser from './urlParser';
import scrollToAnchor from './scrollToAnchor';
import hideLoadingImage from './common/hideLoadingImage';

setup();

document.head.appendChild(
	languageBasedTag(),
);

setBookingLink($('#bookLink'));

const wordingJsonPromise = getWordingJson('room-info')
	.then((json) => wordingSetter(json));

const roomDetailPromise = getRoomDetail(window.location.pathname.split('/')[3])
	.then((json) => {
		document.querySelector('.nest-menu > .current').innerText = json.name;
		document.querySelector('.section-half > .content > .title').innerText = json.name;
		document.querySelector('.section-half > .content > .content').innerText = json.introduction;
		document.querySelector('.section-half > .image').setAttribute(
			'style',
			`background-image: url(${uploadUri}/${json.cover})`,
		);
		document.querySelector('.pickup').innerText = json.pickup;

		/**
		 * room introductions
		 */
		let roomHtml = '';
		json.types.forEach((type) => {
			roomHtml += generateRoomWrapper(type);
		});
		$('.room-block').html(roomHtml);

		/**
		 * attention notes
		 */
		let attentionHtml = '';
		json.attentions.forEach((value) => {
			attentionHtml += `<li>${value}</li>`;
		});
		$('.note-block > ol').html(attentionHtml);

		/**
		 * show/hide detail description area
		 */
		$('.more').on('click', (e) => {
			$(e.currentTarget.parentElement.nextElementSibling).slideToggle('-hide');
		});

		Swiper('.swiper-container.-room', {
			loop: true,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
		});
	})
	.then(() => {
		scrollToAnchor(window.location.hash);
	})
	.catch(({ error_msg: errorMsg }) => {
		if (errorMsg === 'NOT_FOUND') {
			window.location.href = 'room';
		}
	});

/**
 * make sure each promise is finished
 */
const promiseArray = [wordingJsonPromise, roomDetailPromise];

if (urlParser.language !== 'en') {
	const promotionListPromise = getPromotionList('room')
		.then((json) => {
			json.promotions.forEach((item) => {
				document.querySelector('.swiper-container.-promotions > .swiper-wrapper').appendChild(
					wrapSwiperSlide(
						generateLinkCard(
							item.id,
							item.type,
							item.title,
							item.date_start,
							`${uploadUri}/${item.thumb}`,
							item.link,
						),
					),
				);
			});

			const slideCount = json.promotions.length;

			Swiper('.swiper-container.-promotions', {
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				speed: 800,
				slidesPerView: 3,
				slidesPerGroup: 1,
				centeredSlides: slideCount < 2,
				spaceBetween: 30,
				loop: slideCount > 3,
				breakpoints: {
					768: {
						slidesPerView: 1,
						loop: slideCount > 1,
					},
					1160: {
						slidesPerView: 2,
						loop: slideCount > 2,
					},
				},
			});
		});
	promiseArray.push(promotionListPromise);
}

Promise.all(promiseArray)
	.then(() => hideLoadingImage());



// WEBPACK FOOTER //
// ./src/js/rooms-info.js